
const quickformDbGeneral   = require ('./quickform-db-general')
const quickformForm        = require ('./quickform-form')
const quickformHandler     = require ('./quickform-handler')
const inf                  = require ('../../js-network/inf')
const quickform            = require ('./quickform')
 


//click to add new one fabGeneral
export function prepareAdd(detail, htmlQf,callback){  

    quickformHandler.prepareAdd( detail, htmlQf) 

    if(callback != undefined){callback(htmlQf)}

    return true
}/**/


//click to add new one fab on the entity
export function addOne(detail, htmlQf, callback){ 
    
  
    //get values from input to form //red posible you are doint this twice
    quickformForm.getValues( htmlQf )

    //verify if all require are fill
    if( quickformForm.checkRequired(htmlQf, true) ){ 
      return false
    }

    //get inf for the insert
    inf.toInsert(detail, htmlQf)

    // console.log('inftoInsert', detail.inf)
    quickformDbGeneral.addOne(detail, htmlQf, (data, result)=>{ //console.log('addOne>', result)
        data.dest   = detail.dest

        const sendDetail = { to:'allStaff', from:'staffDesktop', id:'' }
        websocket.entityUpdate("entityUpdate", 'addRow', data, sendDetail)   
    
        //return the callback if this exist
        if(callback != undefined){ callback(data, result) }
    })

    return true

}/**/


/**/   
export function hide(detail, htmlQf){ 

    //if wasn't edited just clean and hide    
    quickformForm.clean(htmlQf)
    quickformForm.cleanFromValues( htmlQf )

    quickform.start({act:'hide', html: htmlQf.quickformHTML})

    return true
}/**/



